
















import { OpsGenieChannelDetails, SlackChannelDetails, WebhookChannelDetails } from '@/types';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class URLIntegration extends Vue {
  @Prop() private integrationDetails!: SlackChannelDetails | OpsGenieChannelDetails | WebhookChannelDetails;
  @Getter private hasPermission!: any;
  private url: string = 'https://';


  private readonly rules: any = {
    required: (value: string) => !!value || 'URL is required.',
    url: (value: string) => {
      const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
      return pattern.test(value) || 'Invalid URL.';
    },
  };

  private get prefixedUrl(): string {
    if (!this.integrationDetails.url) {
      return this.url;
    } else {
      return this.integrationDetails.url;
    }
  }

  private handleErrorChange(value: boolean) {
    this.$emit('validate', !value);
  }
}
